export const DROPDOWN_SIZES = {
  s: "min-w-[140px]",
  m: "min-w-[249px]",
  l: "min-w-[257px]",
};
